import ElTableColumnEdit from './table-column';

/* istanbul ignore next */
ElTableColumnEdit.install = function(Vue) {
	if (typeof window !== 'undefined' && window.Vue) {
	  Vue = window.Vue
	}
	Vue.component(ElTableColumnEdit.name, ElTableColumnEdit);
};

export default ElTableColumnEdit;



// WEBPACK FOOTER //
// ./src/index.js